<template>
  <div class="col table-responsive">
    <!-- table for adhesiontests -->
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">G01</th>
          <th scope="col">G02</th>
          <th scope="col">G03</th>
          <th scope="col">G04</th>
          <th scope="col">G05</th>
          <th scope="col">G06</th>
          <th scope="col">G07</th>
          <th scope="col">R01</th>
          <th scope="col">R02</th>
          <th scope="col">R03</th>
          <th scope="col">R04</th>
          <th scope="col">R05</th>
          <th scope="col">R06</th>
          <th scope="col">R07</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in entries" :key="entry.foilPeelTestId">
          <td>{{ entry.foilPeelTestId }}</td>
          <td
            v-for="(value, gIndex) in entry.adhesionEva"
            :key="'g-' + entry.foilPeelTestId + '-' + gIndex"
          >
            {{ value }}
          </td>
          <td
            v-for="(value, rIndex) in entry.adhesionBacksheet"
            :key="'r-' + entry.foilPeelTestId + '-' + rIndex"
          >
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  urlAdhesionTest: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;
  } catch (error) {
    if (error.response) {
      console.error(`HTTP error! Status: ${error.response.status}`);
    } else {
      console.error("Netzwerkproblem:", error.message);
    }
  }
};

onMounted(() => {
  fetchData(props.urlAdhesionTest);
});
</script>
